import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-5 lg:px-10 prose prose-neutral">
        <h1 className="font-display uppercase text-4xl text-drosun-text">Privacy Policy</h1>
        <p className="text-drosun-muted">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-8">Titolare del trattamento</h2>
        <p>Drosun — Building 6, TuoFu SongShanHu Technical Park, No.2 Xinghui Road, Dongguan City, Guandong Province, China, 523451. Email: <a href="mailto:europe@dgdrosun-eu.com" className="text-drosun-red">europe@dgdrosun-eu.com</a>.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-6">Tipi di dati raccolti</h2>
        <p>Tramite il modulo contatti raccogliamo: nome, cognome, telefono, email e il contenuto del messaggio inviato. I dati sono trattati al solo scopo di rispondere alla richiesta dell'utente.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-6">Base giuridica e finalità</h2>
        <p>Il trattamento si basa sul consenso espresso dell'utente (art. 6.1.a GDPR) e sull'esecuzione di misure precontrattuali (art. 6.1.b GDPR). I dati non vengono utilizzati per profilazione o marketing.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-6">Conservazione dei dati</h2>
        <p>I dati sono conservati per il tempo strettamente necessario a evadere la richiesta e comunque non oltre 24 mesi.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-6">Diritti dell'utente</h2>
        <p>L'utente può in qualsiasi momento esercitare i diritti previsti dagli artt. 15-22 GDPR (accesso, rettifica, cancellazione, limitazione, portabilità e opposizione) scrivendo a <a href="mailto:europe@dgdrosun-eu.com" className="text-drosun-red">europe@dgdrosun-eu.com</a>.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-6">Cookie</h2>
        <p>Per maggiori informazioni sull'uso dei cookie consulta la <Link to="/cookie" className="text-drosun-red">Cookie Policy</Link>.</p>
      </div>
    </section>
  );
}
